<template>

    <div>
        <v-app>
            <v-toolbar flat color="white">
                <v-toolbar-title class="congatec-gray">User preferences</v-toolbar-title>
                <v-spacer></v-spacer>
            </v-toolbar>

            <v-divider></v-divider>

            <v-toolbar flat color="transparent" v-if="error" style="position: absolute">
                <v-spacer></v-spacer>

                <v-alert :value="error" :type="color" transition="scale-transition">
                    {{errorMessage}}
                    <v-btn small flat icon color="white" @click="clearAlert">
                        <v-icon>fas fa-times</v-icon>
                    </v-btn>
                </v-alert>

            </v-toolbar>


            <v-card flat>
                <v-card-text>
                    <v-layout wrap>
                        <v-flex xs4 sm3 md2 class="modal-flex-height">
                            <v-subheader>Username</v-subheader>
                        </v-flex>
                        <v-flex xs7 sm5 md4 class="modal-flex-height compact-form">
                            <v-text-field
                                    id="user_preferences_user_name_field"
                                    name="userName"
                                    v-model="user.userName"
                                    color="grey darken-2"
                                    :disabled="true"
                                    class="text-xs-left"
                                    v-validate="'required:true'"
                                    :error-messages="errors.first('userName')"
                            ></v-text-field>
                        </v-flex>
                        <v-flex xs1 sm4 md6 class="modal-flex-height compact-form"></v-flex>


                        <v-flex xs4 sm3 md2 class="modal-flex-height">
                            <v-subheader>Firstname</v-subheader>
                        </v-flex>
                        <v-flex xs7 sm5 md4 class="modal-flex-height compact-form">
                            <v-text-field
                                    id="user_preferences_first_name_field"
                                    name="firstName"
                                    v-model="user.firstName"
                                    color="grey darken-2"
                                    :disabled="disabled"
                            ></v-text-field>
                        </v-flex>
                        <v-flex xs1 sm4 md6 class="modal-flex-height compact-form"></v-flex>


                        <v-flex xs4 sm3 md2 class="modal-flex-height">
                            <v-subheader>Lastname</v-subheader>
                        </v-flex>
                        <v-flex xs7 sm5 md4 class="modal-flex-height compact-form">
                            <v-text-field
                                    id="user_preferences_last_name_field"
                                    name="lastName"
                                    v-model="user.lastName"
                                    color="grey darken-2"
                                    :disabled="disabled"
                            ></v-text-field>
                        </v-flex>
                        <v-flex xs1 sm4 md6 class="modal-flex-height compact-form"></v-flex>


                        <v-flex xs4 sm3 md2 class="modal-flex-height">
                            <v-subheader>Email</v-subheader>
                        </v-flex>
                        <v-flex xs7 sm5 md4 class="modal-flex-height compact-form">
                            <v-text-field
                                    id="user_preferences_email_field"
                                    name="email"
                                    v-model="user.email"
                                    color="grey darken-2"
                                    :disabled="disabled"
                            ></v-text-field>
                        </v-flex>
                        <v-flex xs1 sm4 md6 class="modal-flex-height compact-form"></v-flex>


                        <v-flex xs4 sm3 md2 class="modal-flex-height">
                            <v-subheader>Password</v-subheader>
                        </v-flex>
                        <v-flex xs7 sm5 md4 class="modal-flex-height compact-form">
                            <v-text-field
                                    id="user_preferences_password_field"
                                    name="password"
                                    v-model="user.password"
                                    color="grey darken-2"
                                    :readonly="!showField('password')"
                                    :append-icon="show ? 'visibility' : 'visibility_off'"
                                    :type="show ? 'text' : 'password'" @click:append="show = !show"
                                    ref="password"
                                    v-validate.immediate="'required_if:createUserMode,true'"
                                    :error-messages="errors.first('password')"
                            ></v-text-field>
                        </v-flex>

                        <v-flex xs1 sm1 md1 class="modal-flex-height text-xs-left"
                                v-if="!showField('password')" style="text-align: initial;">

                            <v-btn id="user_preferences_edit_password_button" flat icon small
                                   @click="focusField('password')">
                                <v-icon dark>edit</v-icon>
                            </v-btn>
                        </v-flex>
                        <v-flex xs1 sm1 md1 class="modal-flex-height text-xs-left" v-else>
                            <v-btn id="user_preferences_confirm_password_change_button" flat icon small color="success"
                                   @click="blurField()">
                                <v-icon>check_circle</v-icon>
                            </v-btn>
                        </v-flex>
                        <v-flex xs1 sm3 md5 class="modal-flex-height compact-form"></v-flex>


                        <v-flex xs4 sm3 md2 class="modal-flex-height" v-if="showField('password')">
                            <v-subheader>Password repeat</v-subheader>
                        </v-flex>
                        <v-flex xs7 sm5 md4 class="modal-flex-height compact-form" v-if="showField('password')">
                            <v-text-field id="user_preferences_repeat_password_field"
                                          name="passwordRepeat"
                                          v-model="user.passwordRepeat"
                                          color="grey darken-2"
                                          :disabled="!showField('password')"
                                          v-validate="'required|confirmed:password'"
                                          :error-messages="errors.first('passwordRepeat')"
                                          :append-icon="show ? 'visibility' : 'visibility_off'"
                                          :type="show ? 'text' : 'password'" @click:append="show = !show"
                            ></v-text-field>
                        </v-flex>
                        <v-flex xs1 sm1 md1 v-if="showField('password')" class="text-xs-left">
                            <v-btn id="user_preferences_cancel_password_change_button" flat icon small
                                   @click="cancelField()">
                                <v-icon dark>remove_circle</v-icon>
                            </v-btn>
                        </v-flex>

                        <!-- this checkbox is only a helper to validate that the password is only in creation mode required-->
                        <v-checkbox ref="createUserMode" name="createUserMode" v-model="createUser"
                                    v-show="false"></v-checkbox>

                    </v-layout>

                </v-card-text>

                <v-flex xs6 sm6 md6 lg7 style="margin-top: 40px;">
                    <v-divider></v-divider>
                </v-flex>

                <v-card-actions>
                    <v-flex xs5 sm5 md5>

                    </v-flex>
                    <v-flex xs7 sm5 md4>
                        <v-btn id="user_preferences_save_button" class="text-none" color="green" small dark
                               @click="onSaveUser" :disabled="disabled">Save changes
                        </v-btn>
                    </v-flex>
                    <v-flex xs1 sm4 md6></v-flex>

                    <v-spacer></v-spacer>

                </v-card-actions>
            </v-card>


        </v-app>
    </div>


</template>

<script>
    import userinterface from "../../../interfaces/userinterface";
    import errormessagemanager from "../../../managers/errormessagemanager";

    export default {
        name: 'UserPreferences',

        data: () => ({
            user: {
                userId: null,
                userName: null,
                firstName: null,
                lastName: null,
                password: null,
                passwordRepeat: null,
                email: null,
                isActive: false
            },

            editField: '',
            error: false,
            errorMessage: null,
            color: "",
            createUser: false,

            show: false,
        }),

        components: {},

        created() {
            this.initialize();
        },

        computed: {
            disabled: function () {
                return this.showField('password');
            }
        },

        methods: {
            initialize() {
                userinterface.getCurrentUser(user => {
                    this.user = user;
                })
            },

            async onSaveUser() {
                this.clearAlert();

                this.$validator.validateAll().then(async result => {
                    let response = null;

                    if (result) {
                        await userinterface.putUser(this.user, res => {
                            response = res;
                        });
                    }

                    if (response != null && response.error) {

                        errormessagemanager.getUpdateErrorMessage(response.status, message => {
                            this.errorMessage = message;
                        });
                        this.color = "error";
                        this.error = response.error;

                    } else if (!this.error) {
                        this.initialize();
                        this.error = true;
                        this.errorMessage = "Your user was successfully updated.";
                        this.color = "success";
                    }
                });
            },


            focusField(name) {
                this.editField = name;
            },

            blurField() {
                this.$validator.validateAll().then((result) => {
                    if (result) {
                        this.editField = '';
                    }
                })

            },

            cancelField() {
                this.editField = '';
            },

            showField(name) {
                return this.editField === name;
            },

            clearAlert() {
                this.error = false;
                this.errorMessage = "";
                this.color = "";
            }
        }
    }
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/components/common/users/UserPreferences.vue